import styled from "styled-components"

export const Box = styled.div`
  display: flex;
  justify-content: space-between;
`
export const BoxTwo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`
export const Button = styled.div`
  background: #000000;
  border-radius: 5px;
  min-width: 40px;
  height: 41px;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
`
export const Padding = styled.div`
  padding: 0 40px 40px 40px;
`
export const Line = styled.div`
  background: #333333;
  height: 1px;
  width: 100%;
  margin-bottom: 27px;
`
